interface Step {
  index: number;
  label: string;
}

interface WizardStepperProps {
  currentStep: number;
  steps: Step[];
}

export default function WizardStepper({ currentStep, steps }: WizardStepperProps) {
  return (
    <div
      className="w-full flex border-b"
      style={{ background: '#fff', borderColor: '#E5E5E8' }}
    >
      {steps.map((step) => {
        const isCompleted = step.index < currentStep;
        const isActive = step.index === currentStep;

        return (
          <div
            key={step.index}
            className="flex-1 flex items-center justify-center gap-2.5 py-4 px-4 transition-all"
            style={{
              background: isActive ? '#1A1A1A' : '#fff',
              borderRight: step.index < steps.length ? '1px solid #E5E5E8' : 'none',
              cursor: isCompleted ? 'pointer' : 'default',
            }}
          >
            {isCompleted ? (
              <span
                className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ background: '#E8F5EE', border: '1.5px solid #2E7D32' }}
              >
                <i className="ri-check-line text-[10px] font-bold" style={{ color: '#2E7D32' }} />
              </span>
            ) : (
              <span
                className="w-5 h-5 rounded-full flex items-center justify-center text-[11px] font-bold flex-shrink-0"
                style={{
                  background: isActive ? '#fff' : '#F0F0F2',
                  color: isActive ? '#1A1A1A' : '#8B8B94',
                  border: isActive ? 'none' : '1.5px solid #DCDCE0',
                }}
              >
                {step.index}
              </span>
            )}
            <span
              className="text-sm font-medium whitespace-nowrap"
              style={{
                color: isActive ? '#fff' : isCompleted ? '#1A1A1A' : '#8B8B94',
              }}
            >
              {step.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
